import { LayoutGrid, ShoppingBag, FileText, Clock } from "lucide-react";
import { NavLink } from "@/components/NavLink";
import { cn } from "@/lib/utils";

const items = [
  { title: "Dashboard", url: "/dashboard", icon: LayoutGrid },
  { title: "Orders", url: "/orders", icon: ShoppingBag },
  { title: "Receipts", url: "/receipts", icon: FileText },
  { title: "Outstanding", url: "/outstanding", icon: Clock },
];

export function MobileNav() {
  return (
    <nav className="lg:hidden fixed bottom-0 left-0 right-0 z-50 bg-card border-t">
      <div className="grid grid-cols-4 h-16">
        {items.map((item) => {
          const Icon = item.icon;
          return (
            <NavLink
              key={item.title}
              to={item.url}
              className="flex flex-col items-center justify-center gap-1 text-xs transition-colors text-muted-foreground"
              activeClassName="text-primary"
            >
              <Icon className="h-5 w-5" />
              <span>{item.title}</span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
